
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.778 18.778"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"facebook(13)","d":"M16.027 0H2.751A2.754 2.754 0 000 2.751v13.276a2.754 2.754 0 002.751 2.751h5.538V12.14h-2.2v-3.3h2.2V6.6a3.3 3.3 0 013.3-3.3h3.337v3.3h-3.337v2.239h3.337l-.55 3.3h-2.787v6.638h4.438a2.754 2.754 0 002.751-2.751V2.751A2.754 2.754 0 0016.027 0zm0 0","fill":"#fff"}})])
          )
        }
      }
    